import React, { Component } from 'react';
import RarocHeader from '../Header/Header';
import './OverviewWholeBank.style.scss';
import AssetStructure from './components/AssetStructure/AssetStructure';
import Car from './components/Car/Car';
import EconomicCapital from './components/EconomicCapital/EconomicCapital';
import EconomicProfit from './components/EconomicProfit/EconomicProfit';
import FeeCommission from './components/FeeCommission/FeeCommission';
import LiabilitiesStructure from './components/LiabilitiesStructure/LiabilitiesStructure';
import Deposit from './components/LoanAndDeposit/Deposit';
import Loan from './components/LoanAndDeposit/Loan';
import Note from './components/Note/Note';
import OpexStructure from './components/OpexStructure/OpexStructure';
import NIM from './components/PercentChart/NIM';
import NPL from './components/PercentChart/NPL';
import RAROC from './components/PercentChart/RAROC';
import ROA from './components/PercentChart/ROA';
import ROE from './components/PercentChart/ROE';
import PerformanceChange from './components/PerformanceChange/PerformanceChange';
import ProfitAndLoss from './components/ProfitAndLoss/ProfitAndLoss';
import RarocBar from './components/RarocBar/RarocBar';
import RiskAsset from './components/RiskAsset/RiskAsset';
import ToiStructure from './components/ToiStructure/ToiStructure';
import TotalAssetUp from './components/TotalAsset/TotalAssetUp';
import TotalLiabilitiesUp from './components/TotalLiabilities/TotalLiabilitiesUp';
// import {DropdownButton, MenuItem} from 'react-bootstrap';

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
export default class OverviewWholeBank extends Component {
  renderFilter() {
    return (
      <div style={{ display: 'flex', gap: 8 }}>
        <SelectField
          floatingLabelStyle={{ fontSize: 12, color: '#49454F' }}
          selectedMenuItemStyle={{ color: '#1D1B20', fontWeight: 600 }}
          menuItemStyle={{ color: '#1D1B20', fontSize: 14 }}
          style={{ width: 150, fontSize: 14 }}
          floatingLabelText='Filter'
          value={'BANKWIDE'}>
          <MenuItem value={'BANKWIDE'} primaryText={'BANKWIDE'} />
        </SelectField>
        <SelectField
          floatingLabelStyle={{ fontSize: 12, color: '#49454F' }}
          selectedMenuItemStyle={{ color: '#1D1B20', fontWeight: 600 }}
          menuItemStyle={{ color: '#1D1B20', fontSize: 14 }}
          style={{ width: 144, fontSize: 14 }}
          floatingLabelText='Snapshot date'
          value={this.props.reportDate}
          onChange={(event, index, value) => {
            this.props.onChangeDate(value);
          }}>
          {this.props.snapshotDates &&
            this.props.snapshotDates.map((date) => (
              <MenuItem key={date} value={date} primaryText={date} />
            ))}
        </SelectField>
      </div>
    );
  }
  render() {
    return (
      <div className='overview-container card'>
        <RarocHeader
          title={'OVERVIEW DASHBOARD (APPLICABLE FOR WHOLE BANK, LOB)'}
          filter={this.renderFilter()}
        />
        <div className='flex-row-container'>
          <div className='overview-asset'>
            <TotalAssetUp />
            <TotalLiabilitiesUp />
          </div>
          <div className='overview-structure'>
            <div style={{ flex: 1 }}>
              <AssetStructure />
            </div>
            <div style={{ flex: 1 }}>
              <LiabilitiesStructure />
            </div>
          </div>
        </div>
        <div className='flex-row-container'>
          <div className='overview-asset'>
            <Loan />
            <Deposit />
          </div>
          <div className='overview-structure'>
            <ProfitAndLoss data={this.props.data} />
          </div>
        </div>

        <div className='flex-row-container'>
          <div className='structure-charts'>
            <div style={{ flex: 1 }}>
              <ToiStructure />
            </div>
            <div style={{ flex: 1 }}>
              <FeeCommission />
            </div>
          </div>
          <div className='grid-charts'>
            <div className='col-2'>
              <div className='flex-row'>
                <div style={{ flex: 1 }}>
                  <EconomicCapital data={this.props.data} />
                </div>

                <div style={{ minWidth: '40%' }}>
                  <Car data={this.props.data} />
                </div>
              </div>
              <div style={{ flex: 1 }}>
                <RiskAsset data={this.props.data} />
              </div>
            </div>
            <div className='col-1'>
              <ROE />
              <ROA />
              <RAROC data={this.props.data} />
            </div>
          </div>
        </div>
        <div className='flex-row-container'>
          <div className='flex-col' style={{ flex: 1 }}>
            <div className='structure-charts'>
              <div style={{ flex: '1 1 40%' }}>
                <PerformanceChange />
              </div>
              <div style={{ flex: '1 1 60%' }}>
                <OpexStructure />
              </div>
            </div>
            <div>
              <Note />
            </div>
          </div>

          <div className='flex-col' style={{ flex: 1 }}>
            <div className='grid-charts'>
              <div className='col-2'>
                <EconomicProfit data={this.props.data} />
              </div>
              <div className='col-1'>
                <NIM />
                <NPL />
              </div>
            </div>
            <div>
              <RarocBar data={this.props.data} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/pages/Raroc/Dashboard/OverviewWholeBank/OverviewWholeBank.js